/**
 * EmptyConversations - Estado vazio da lista de conversas.
 */
import React from 'react';
import { AppIcon } from '../../../components/icons/AppIcon';

interface EmptyConversationsProps {
    activeTab: string;
    showUnreadOnly?: boolean;
}

export const EmptyConversations: React.FC<EmptyConversationsProps> = ({ activeTab, showUnreadOnly = false }) => {
    const isFavorites = activeTab === 'favorites';

    return (
        <div className="flex flex-col items-center justify-center px-s6 py-s8 text-center md:py-s12">
            <div
                className="mb-s4 flex size-14 items-center justify-center rounded-full bg-surface-subtle text-muted md:size-16"
                aria-hidden
            >
                <AppIcon
                    name={isFavorites ? 'star' : 'search'}
                    className="size-7 md:size-8"
                />
            </div>
            <p className="text-body-md font-medium text-default">
                {showUnreadOnly
                    ? 'Nenhuma conversa não lida.'
                    : isFavorites
                        ? 'Nenhuma conversa favorita.'
                        : 'Nenhuma conversa encontrada.'}
            </p>
            {isFavorites && !showUnreadOnly && (
                <p className="text-caption mt-s2 max-w-xs">
                    Clique na estrela no cabeçalho de uma conversa para favoritar.
                </p>
            )}
        </div>
    );
};
